import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response, ResponseContentType} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import { ActivityLog } from 'shared/classes/activityLog';

@Injectable()
export class HomeRepository {

  constructor(private http: Http) { }

  public getActivityAll(from: string, to: string): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.activityAll}?from=${from}&to=${to}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAnswerActivityAll(systemName: string, from: string, to: string): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.answerActivityAll}?systemName=${systemName}&from=${from}&to=${to}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getActivityByCompany(from: string, to: string): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.activityByCompany}?from=${from}&to=${to}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAnswerActivityByCompany(systemName: string, from: string, to: string): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.answerActivityByCompany}?systemName=${systemName}&from=${from}&to=${to}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getThesisActivityByCompany(from: string, to: string): Observable<Dictionary<Array<ActivityLog>>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.thesisActivityByCompany}?from=${from}&to=${to}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getDialogAnswerActivityByCompany(from: string, to: string): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.dialogAnswerActivityByCompany}?from=${from}&to=${to}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getUsersCreated(): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.usersCreated}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getUsersFirstUsed(): Observable<Array<any>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.home.usersFirstUsed}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/home/repositories/home.repository.ts